import _toConsumableArray from "F:\\\u80F6\u5DF1\u4EBA\\jjr_store_reservation\\node_modules\\@babel\\runtime\\helpers\\esm\\toConsumableArray.js";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import _asyncToGenerator from "F:\\\u80F6\u5DF1\u4EBA\\jjr_store_reservation\\node_modules\\@babel\\runtime\\helpers\\esm\\asyncToGenerator.js";
import _defineProperty from "F:\\\u80F6\u5DF1\u4EBA\\jjr_store_reservation\\node_modules\\@babel\\runtime\\helpers\\esm\\defineProperty.js";
import "vant/es/card/style";
import _Card from "vant/es/card";
import "vant/es/pull-refresh/style";
import _PullRefresh from "vant/es/pull-refresh";
import "vant/es/list/style";
import _List from "vant/es/list";
import "vant/es/swipe-item/style";
import _SwipeItem from "vant/es/swipe-item";
import "vant/es/swipe/style";
import _Swipe from "vant/es/swipe";
import "vant/es/tabbar-item/style";
import _TabbarItem from "vant/es/tabbar-item";
import "vant/es/tabbar/style";
import _Tabbar from "vant/es/tabbar";
import "vant/es/button/style";
import _Button from "vant/es/button";

var _components;

import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { userInfo } from '@/api/user';
import { rotation, list } from '@/api/goods';
import { getURLParam } from '@/utils/common';
export default {
  name: 'Home',
  components: (_components = {}, _defineProperty(_components, _Button.name, _Button), _defineProperty(_components, _Tabbar.name, _Tabbar), _defineProperty(_components, _TabbarItem.name, _TabbarItem), _defineProperty(_components, _Swipe.name, _Swipe), _defineProperty(_components, _SwipeItem.name, _SwipeItem), _defineProperty(_components, _List.name, _List), _defineProperty(_components, _PullRefresh.name, _PullRefresh), _defineProperty(_components, _Card.name, _Card), _components),
  data: function data() {
    return {
      tabbarActive: 'home',
      images: [],
      // 轮播图
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      filterData: {
        limit: 10,
        page: 0 // store_id: localStorage.getItem('adl_store_id')

      },
      storeId: null,
      isLogin: true
    };
  },
  created: function created() {
    this.getSwipeArr();

    if (getURLParam('store_id')) {
      localStorage.setItem('adl_store_id', getURLParam('store_id'));
    }

    if (getURLParam('store_name')) {
      localStorage.setItem('adl_store_name', decodeURI(getURLParam('store_name')));
    }
  },
  methods: {
    // 获取轮播图
    getSwipeArr: function getSwipeArr() {
      var _this = this;

      rotation().then(function (res) {
        if (res.error.code === 0) {
          var swipeArr = res.data.map(function (item) {
            return item.img;
          });
          _this.images = swipeArr;
        }
      });
    },
    // 获取用户信息，作用：未登录门店id=0
    getUser: function getUser() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return userInfo().then(function (res) {
                  if (res.error.code === 0) {
                    _this2.isLogin = true;
                    _this2.filterData.store_id = res.data.store_id;
                    var beforeStoreId = res.data.store_id; // 绑定的id

                    // 绑定的id
                    var beforeStoreName = res.data.store_name; // 绑定的name

                    // 绑定的name
                    var nowStoreId = localStorage.getItem('adl_store_id'); // 现在扫码的id

                    // 现在扫码的id
                    if (Number(nowStoreId) !== beforeStoreId && !window.HAS_TIPS) {
                      _Dialog.confirm({
                        title: '',
                        message: "\u60A8\u5DF2\u7ECF\u6CE8\u518C\u5230\u3010".concat(beforeStoreName, "\u3011"),
                        showCancelButton: false
                      }).then(function () {
                        window.HAS_TIPS = true; // 判断全局变量，用于处理扫码进首页重复判断“您已绑定**门店”

                        // 判断全局变量，用于处理扫码进首页重复判断“您已绑定**门店”
                        localStorage.setItem('adl_store_id', beforeStoreId); // 提示完后把本地存储的门店id改成绑定的，这样就不会每次到首页都跳弹框
                      });
                    }
                  } else {
                    _this2.isLogin = false;
                    _this2.filterData.store_id = 0;
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 列表
    getList: function getList(refresh) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _self;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _self = _this3;
                _context2.next = 3;
                return list(_this3.filterData).then(function (res) {
                  if (res.error.code === 0) {
                    // 加载状态结束
                    _self.loading = false; // 数据全部加载完成

                    // 数据全部加载完成
                    if (refresh === 'refresh') {
                      _this3.list = res.data.list;
                    } else {
                      var tempList = [].concat(_toConsumableArray(_this3.list), _toConsumableArray(res.data.list));
                      _this3.list = tempList;
                    }

                    if (_this3.list.length >= res.data.totalCount) {
                      _self.finished = true;
                    } else {
                      _self.finished = false;
                    }
                  }
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onLoad: function onLoad() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.filterData.page += 1;
                _context3.next = 3;
                return _this4.getUser();

              case 3:
                _context3.next = 5;
                return _this4.getList();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onRefresh: function onRefresh() {
      this.refreshing = false;
      this.finished = true; // 防止下拉刷新发送了两次请求的问题

      this.filterData.page = 1;
      this.getList('refresh');
      this.list = [];
    },
    // 切换菜单
    changeTabbar: function changeTabbar(e) {
      if (e === 'home') {
        this.$router.push({
          name: 'home'
        });
      } else if (e === 'case') {
        this.$router.push({
          name: 'case'
        });
      } else if (e === 'package') {
        this.$router.push({
          name: 'package'
        });
      } else if (e === 'personal') {
        this.$router.push({
          name: 'personal'
        });
      }
    },
    // 进入详情
    detailGo: function detailGo(item) {
      if (this.isLogin) {
        this.$router.push({
          name: 'homeDetails',
          query: {
            id: item.id
          }
        });
      } else {
        _Dialog.confirm({
          title: '',
          message: '您还未登录/注册！',
          showCancelButton: false
        }).then(function () {});
      }
    }
  }
};